
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"88","height":"88","viewBox":"0 0 88 88","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#181e25","stroke-width":"2","d":"M44.999.328v10.918M51.819 1.02l-1.708 10.783M58.447 2.774l-3.374 10.384M64.718 5.54l-4.957 9.728M70.479 9.256l-6.417 8.833M75.588 13.824l-7.72 7.721M79.92 19.137l-8.833 6.418M83.367 25.063l-9.729 4.957M85.844 31.455L75.46 34.829M87.291 38.156l-10.784 1.708M87.672 45H76.754M86.978 51.82l-10.783-1.708M85.226 58.447l-10.384-3.374M82.459 64.719l-9.728-4.957M78.744 70.481l-8.833-6.418M74.174 75.586l-7.72-7.72M68.861 79.92l-6.418-8.833M62.936 83.364l-4.957-9.728M56.544 85.844L53.171 75.46M49.844 87.293l-1.708-10.784M43 87.676V76.758M36.181 86.98l1.708-10.783M29.553 85.226l3.374-10.384M23.282 82.46l4.957-9.728M17.521 78.748l6.417-8.833M12.412 74.176l7.72-7.721M8.08 68.863l8.833-6.418M4.633 62.937l9.728-4.957M2.156 56.545l10.384-3.374M.709 49.848l10.783-1.708M.327 43.004h10.918M1.022 36.18l10.783 1.708M2.774 29.557l10.384 3.374M5.541 23.281l9.729 4.957M9.256 17.523l8.833 6.418M13.826 12.414l7.721 7.72M19.139 8.084l6.418 8.833M25.064 4.636l4.957 9.728M31.456 2.156l3.373 10.384M38.156.707l1.708 10.784"}})])
          )
        }
      }
    